import "./index.scss";
import m from "mithril";
import {Icon, Spinner} from "../../../old/tools/constructui";
import classNames from "classnames";
import imageLocationCapture from "./image-location-capture";

// import newButton from "./new-button";

const oldButton = () => {
	async function PerformOnClick(onclick) {
		if (onclick) {
			return await onclick();
		} else return;
	}

	let clicked = false;
	let success = false;
	return {
		view: ({
			attrs: {
				href,
				label,
				icon,
				iconLeft,
				disabled,
				loading,
				minwidth,
				small = false,
				onclick,
				basic,
				fluid = false,
				...htmlAttrs
			},
		}) => {
			const tag = href ? "a" : "button";
			const isAnchor = tag === "a";
			loading = clicked || loading;
			disabled = clicked || disabled;
			const content = [
				loading && m(Spinner, {active: true, fill: true}),
				(iconLeft || icon) && m(".icon-section", m(Icon, {name: iconLeft || icon})),
				label && m(".label-section", label),
			];
			// console.log({loading, iconLeft, label, content});

			return m(
				// tag == "a" ? m.route.Link : "button",
				tag,
				{
					style: {
						"--button-height": small ? "1.4rem" : "1.8rem",
					},
					...htmlAttrs,
					class: classNames(
						"prasora-component-button",
						basic ? "basic" : "normal",
						(iconLeft || icon) && "has-icon",
						label && "has-label",
						(iconLeft || icon) && !label && "only-icon",
						loading && "loading",
						fluid && "fluid",
						htmlAttrs.class
					),
					// style: minwidth && `min-width: ${minwidth};`,
					type: isAnchor ? undefined : "button",
					role: isAnchor ? "button" : undefined,
					// class: classes,
					// Undefined attrs are not removed on redraw. See https://github.com/MithrilJS/mithril.js/pull/1865#issuecomment-382990558'
					href: disabled ? undefined : href,
					onclick: disabled
						? undefined
						: () => {
								clicked = true;
								// console.log({ clicked });
								PerformOnClick(onclick).then(() => {
									clicked = false;
									// console.log({clicked});
									m.redraw();
								});
						  },
					tabIndex: disabled ? undefined : htmlAttrs.tabIndex,
				},
				content
			);
		},
	};
};

export default oldButton;
